import { useMemo } from "react";
import { BrandThemeContext } from "@/features/theme/context/BrandThemeContext";
import { useBrandThemeQuery } from "@/features/theme/hooks/useBrandThemeQuery";
import type { BrandThemeContextValue } from "@/features/theme/types/brandTheme.type";
import { useBrandColors } from "@/shared/hooks/useBrandColors";

type BrandThemeProviderProps = { children: React.ReactNode };

export const BrandThemeProvider = ({ children }: BrandThemeProviderProps) => {
  const {
    brandTheme, isLoading, isError, source,
  } = useBrandThemeQuery();

  // Apply CSS brand color variables (same effect as the old AuthProvider call)
  const themeConfigForColors = useMemo(() => {
    if (!brandTheme?.colors) return null;
    return { colors: brandTheme.colors };
  }, [brandTheme?.colors]);

  useBrandColors(themeConfigForColors);

  const value: BrandThemeContextValue = useMemo(() => ({
    brandTheme,
    isLoading,
    isError,
    source,
  }), [brandTheme, isLoading, isError, source]);

  return (
    <BrandThemeContext.Provider value={value}>
      {children}
    </BrandThemeContext.Provider>
  );
};

BrandThemeProvider.displayName = "BrandThemeProvider";
